import { CustomDialogConfiguration } from './custom-dialog';

const Commands = [
  'setValue',
  'setCustomConfiguration',
  'show',
  'hide',
  'enable',
  'disable',
  'setError',
  'clearError',
  'setHint',
  'setClass',
  'setLabelClass',
  'setLabelIcon',
] as const;

export type RuleActionCommand = (typeof Commands)[number];

export type RuleTest = Record<string, Record<string, unknown>>;

export interface RuleAction {
  cmd: RuleActionCommand;
  field: string | string[];
  value?: unknown;
  configuration?: CustomDialogConfiguration;
  message?: string;
}

export interface Rule {
  test: RuleTest;
  actions: RuleAction[];
}

export interface RuleSet {
  isEdit: boolean;
  rules: Rule[];
}
